import { createSlice } from "@reduxjs/toolkit";

const initialData = {
  sideNavFlag: false,
  columnData: {
    columns: [],
    local_columns: [],
    editable_global_columns: [],
    non_editable_global_columns: [],
    dropdownOptions: {}
  },
  pageSize: 20,
  dashboardData: {
    kpi: [],
    team_performance_chart: [],
    active_upc: [],
    active_submission: [],
    review_teams: [],
  },
  countryFilterOptions: {
    country: [],
    source: [],
  },
  selectedCountrySource: {
    country: "",
    source: ""
  }
};

const harborSlice = createSlice({
  name: "harbor",
  initialState: initialData,
  reducers: {
    updateSideNavFlag(state, action) {
      state.sideNavFlag = action.payload;
    },
    updateReviewColumnData(state, action) {
      state.columnData = { ...state.columnData, ...action.payload };
    },
    updatePageSize(state, action) {
      state.pageSize = action.payload;
    },
    updateDashboardData(state, action) {
      state.dashboardData = { ...state.dashboardData, ...action.payload };
    },
    updateCountryFilterOptions(state, action) {
      state.countryFilterOptions = { ...state.countryFilterOptions, ...action.payload };
    },
    updateSelectedCountrySource(state, action) {
      state.selectedCountrySource = { ...state.selectedCountrySource, ...action.payload };
    }
  },
});

export const {
  updateSideNavFlag,
  updateReviewColumnData,
  updatePageSize,
  updateDashboardData,
  updateCountryFilterOptions,
  updateSelectedCountrySource
} = harborSlice.actions;

export default harborSlice.reducer;
